/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageWidgetDetail } from '../../models/page-widget-detail';

export interface GetAllAclPageWidgets$Params {
      body: Array<number>
}

export function getAllAclPageWidgets(http: HttpClient, rootUrl: string, params: GetAllAclPageWidgets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PageWidgetDetail>>> {
  const rb = new RequestBuilder(rootUrl, getAllAclPageWidgets.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PageWidgetDetail>>;
    })
  );
}

getAllAclPageWidgets.PATH = '/api/AclRole/aclPageWidgets';
